<template>
  <div class="event-details-box">
    <div class="event-registration-box">
      <payment-summary :formTitle="eventConfig['names-label-your-total']" priceTitle="" :products="products"
                       :donationPrice="donation"/>
    </div>
    <div class="event-form-wrap event-box-shadow">
      <div class="event-rg-form">
        <h6>{{ eventConfig['billto-label-details'] }}</h6>
        <p class="font-weight-light event-info-text">
          {{ eventConfig['billto-label-receipt'] }}
          <el-tooltip :content="eventConfig['billto-label-receipt-details']" placement="top">
            <i data-toggle="tooltip" class="far fa-info-circle"></i>
          </el-tooltip>
        </p>
        <el-button-group>
          <el-button :type="billingType === 'individual' ? 'primary' : 'plain'" @click="billingType = 'individual'">
            Individual
          </el-button>
          <el-button :type="billingType === 'corporate' ? 'primary' : 'plain'" @click="billingType = 'corporate'">
            Organisation
          </el-button>
        </el-button-group>
      </div>
      <keep-alive>
        <component
            :is="activeForm"
            :eventConfig="eventConfig"
            :billingInfo="billingInfo"
            :donationDetail="donationDetail"
            :tickets="tickets"
            :participants="participants"
            @back-step="onBackClick"
            @next-step="onNextClick"
        />
      </keep-alive>
    </div>
  </div><!-- /.event-else-wrapper -->
</template>

<script>
import PaymentSummary from '../../_FormElements/PaymentSummary.vue';

const IndividualBilling = () => import("./Individual.vue");
const CorporateBilling = () => import("./Corporate.vue");

export default {
  components: {
    PaymentSummary
  },
  props: {
    tickets: {type: Array, required: true},
    eventConfig: {type: Object, required: true},
    participants: {type: [Object, Array], required: true},
    billingInfo: Object,
    donationDetail: Object
  },
  data: function () {
    return {
      billingType: 'individual'
    }
  },
  mounted() {
    if (this.billingInfo) {
      this.billingType = this.billingInfo.type;
    }
  },
  computed: {
    products: function () {
      return this.tickets.map(ticket => ({
        'product-code': ticket.code,
        'product-description': ticket.name,
        'total-price': ticket.total
      }));
    },
    activeForm: function () {
      return this.billingType === 'individual' ? IndividualBilling : CorporateBilling;
    },
    donation: function () {
      if (this.participants) {
        return Number(this.participants.customDonation) + Number(this.participants.donation);
      }
      return 0;
    },
  },
  methods: {
    onBackClick: function () {
      this.$emit('next-step', {step: 2});
    },
    onNextClick: function (billingInfo) {
      this.$emit('next-step', {step: 4, billingInfo});
    }
  }
}
</script>



<style lang="scss">
.el-tooltip__popper {
  max-width: 50vw;

  @media(min-width: 800px) {
    max-width: 30vw;
  }
}
</style>

<style lang="scss" scoped>

.el-button-group {
  margin-bottom: 1em;

  button {
    margin-right: 0;
  }
}

</style>